// extracted by mini-css-extract-plugin
export var deliveryRow = "_t5-a";
export var fixedHeight = "_t5-4";
export var freightLogo = "_t5-9";
export var fullWidth = "_t5-3";
export var priceColumn = "_t5-5";
export var radioSelected = "_t5-7";
export var radioUnselected = "_t5-6";
export var selectedOption = "_t5-2";
export var selectedOptionContainer = "_t5-1";
export var selection = "_t5-0";
export var tallSkeletonText = "_t5-8";